import { render } from "./MoneyInfo.vue?vue&type=template&id=3e8d9ecc&scoped=true&ts=true"
import script from "./MoneyInfo.vue?vue&type=script&lang=ts"
export * from "./MoneyInfo.vue?vue&type=script&lang=ts"

import "./MoneyInfo.vue?vue&type=style&index=0&id=3e8d9ecc&lang=scss&scoped=true"

import exportComponent from "/home/app/mt-partners/frontend/affiliate/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e8d9ecc"]])

export default __exports__